module.exports = __webpack_public_path__ + "static/media/guideNotify.f1a2d1da.png";